import { Component, Optional, Inject } from '@angular/core';
import {
  AppDataStore,
  PermissionCheckerService,
  PershingTranslationService,
} from '@pershing/pershing-core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { NxiConfigUtil } from '@pershing/nxi-ng-common';
import {
  CustomHeader,
  AboutUsDialogHeader,
} from '../../utils/navigation.constants';
@Component({
  selector: 'about-us',
  templateUrl: './about-us.component.html',
})
export class AboutUsComponent {
  community: any;
  resourceEntitled: boolean = false;
  entitledForAdvisorInfo: boolean;
  entitledForAboutUs: boolean;
  entitledForContactUs: boolean;
  titleId: any;
  hasAboutUs: boolean = true;
  hasContactUs: boolean = true;
  hasResources: boolean = true;
  articleId: string = 'site_specific_resources';
  aboutUs: string = 'about_us';
  ibd: any;
  isFromSiteBuilder: boolean;
  pathToInvesting: boolean;
  isA3KUser: boolean = false;
  forms: boolean = false;
  constructor(
    private translationService: PershingTranslationService,
    @Optional() @Inject('AppSettings') appSettings: any,
    private authorizationService: PermissionCheckerService,
    public dialogRef: MatDialogRef<AboutUsComponent>,
    public appDataStore: AppDataStore
  ) {
    this.translationService.addTranslationFolder(
      '@pershing/nxi-ng-modern-navigation',
      'node_modules/@pershing/nxi-ng-modern-navigation/lib'
    );
    this.community = NxiConfigUtil.getCommunityName(appSettings);
    this.hasResources = this.resourceEntitled =
      this.authorizationService.isEntitled('OUTSIDE_LINKS');
    this.entitledForAdvisorInfo =
      this.authorizationService.isEntitled('FINANCIAL_ADVISOR');
    this.hasAboutUs = this.entitledForAboutUs =
      this.authorizationService.isEntitled('ABOUT_US');
    this.hasContactUs = this.entitledForContactUs =
      this.authorizationService.isEntitled('CONTACT_BROKERAGE');
    this.ibd = appSettings.ibdConfigMap.IBD;
    this.isFromSiteBuilder = appSettings.isSitebuilder;
    this.pathToInvesting = this.authorizationService.isEntitled("PATH_TO_INVESTING");
    this.forms = this.authorizationService.isEntitled("DOWNLOAD_FORMS");
  }

  ngOnInit(): void {
    this.titleId = this.articleId;
    // customized header are replaced below.
    if (
      CustomHeader.propertyMap.get(this.ibd) &&
      CustomHeader.propertyMap.get(this.ibd).get(this.articleId)
    ) {
      this.titleId = CustomHeader.propertyMap.get(this.ibd).get(this.articleId);
    } else if (
      CustomHeader.propertyMap.get(this.community) &&
      CustomHeader.propertyMap.get(this.community).get(this.articleId)
    ) {
      this.titleId = CustomHeader.propertyMap
        .get(this.community)
        .get(this.articleId);
    }

    if (
      AboutUsDialogHeader.propertyMap.get(this.community) &&
      AboutUsDialogHeader.propertyMap.get(this.community).get(this.aboutUs)
    ) {
      this.aboutUs = AboutUsDialogHeader.propertyMap
        .get(this.community)
        .get(this.aboutUs);
    }
    this.checkIfA3KUser();
  }
  checkIfA3KUser() {
    if (this.ibd === '5DC') {
      let accountDataList = this.appDataStore.get("ACCOUNTS_LIST");
      if (accountDataList?.length > 0) {
        for (let account of accountDataList) {
          if (account?.offNum?.toLowerCase() === 'a3k') {
            this.isA3KUser = true;
            break;
          }
        }
      }
    }
  }

  hasAboutContent(event: any) {
    this.hasAboutUs = event.hasContent;
  }

  hasContactContent(event: any) {
    this.hasContactUs = event.hasContent;
  }

  hasResourcesContent(event: any) {
    this.hasResources = event.hasContent;
  }

  closeDialog() {
    this.dialogRef.close();
  }
  gotoCommissionSchedule(): void {
    document.dispatchEvent(
      new CustomEvent('portal.gotoview', {
        detail: {
          gotoPage: '/nxi/transact/commissionschedule',
        },
      })
    );
    this.closeDialog();
  }
}
